import React, { useCallback, useState } from 'react';
import { FC } from 'react';
import { Button } from '../../base-components/Button';
import useModalState from '../_hooks/useModalState';
import { Benefits } from './components/Benefits';
import { SendMessageForm, Modal } from '../_shared';
import { useScrollToAnchor } from '../Purchases/hooks/useScrollToAnchor';
import { IconDown } from '../Purchases/components/SortOrderSwitch/IconDown';
import styles from './FindSupplier.module.scss';
import { sendTelegramMsg } from './lib/messageApi';
import { validationSchema } from './lib/validationSchema';

export const FindSupplier: FC = () => {
    const [scrollAnchor, scrollToAnchor] = useScrollToAnchor();
    const [isFormModalVisible, showFormModal, hideFormModal] = useModalState();
    const [isSuccessModalVisible, showSuccessModal, hideSuccessModal] =
        useModalState();
    const [successState, setSuccessState] = useState({
        header: 'Ошибка!',
        message: 'Что-то пошло не так. Пожалуйста, попробуйте еще раз',
    });

    const handleFormSubmit = useCallback(
        async (data) => {
            const result = await sendTelegramMsg(data);

            hideFormModal();
            if (result.success) {
                setSuccessState({
                    header: 'Спасибо!',
                    message: 'Скоро мы с Вами свяжемся.',
                });
            }
            showSuccessModal();
        },
        [hideFormModal, showSuccessModal]
    );

    return (
        <section className={styles.section}>
            <div className={styles.container}>
                <div className={styles.wrapper}>
                    <h1>
                        Найти поставщика
                        <br />с помощью электронной
                        <br />
                        площадки
                    </h1>
                    <div className={styles.btnWrapper}>
                        <Button
                            variant="transparent"
                            className={styles.buttonLink}
                        >
                            <a
                                href="https://estp.ru/auth/registration"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Начать самому
                            </a>
                        </Button>
                        <Button
                            variant="blue"
                            className={styles.buttonModal}
                            onClick={showFormModal}
                        >
                            Начать с поддержкой
                        </Button>
                    </div>
                    <img
                        src="/assets/customers/sketch-building.png"
                        alt="ESTP"
                        className={styles.img}
                    />
                    <div className={styles.scrollBtn}>
                        <div onClick={scrollToAnchor}>
                            <p>Наши преимущества</p>
                            <IconDown />
                        </div>
                    </div>
                </div>

                <Benefits />

                {scrollAnchor}

                {isFormModalVisible && (
                    <Modal onHide={hideFormModal} header="Найти поставщика">
                        <SendMessageForm
                            handleSubmit={handleFormSubmit}
                            validationSchema={validationSchema}
                            textAreLabel="Опишите запрос (необязательно)"
                            contactLabel="Номер телефона"
                        />
                    </Modal>
                )}

                {isSuccessModalVisible && (
                    <Modal
                        onHide={hideSuccessModal}
                        header={successState.header}
                        className={styles.responseModal}
                    >
                        <p>{successState.message}</p>
                    </Modal>
                )}
            </div>
        </section>
    );
};
